import React from "react";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import {
  TextField,
  FormLabel,
  FormControlLabel,
  Checkbox
} from "@material-ui/core";

import {
  setStartDate,
  setEndDate,
  setHardCutoff
} from "../../../actions/app/creatives";
import HelperTooltip from "../../Shared/HelperTooltip/HelperTooltip";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    margin: theme.spacing(2)
  },
  textField: {
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(3),
    width: 230
  },
  label: {
    marginTop: theme.spacing(1)
  }
}));

export default function AssetDelivery() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const startDate = useSelector((state) => state.creatives.startDate);
  const endDate = useSelector((state) => state.creatives.endDate);
  const hardCutoff = useSelector((state) => state.creatives.hardCutoff);
  const location = useLocation();

  return (
    <form className={classes.container} noValidate>
      <FormLabel component="legend" className={classes.legend}>
        Delivery Properties
        {!location.pathname.includes("siteserved") && (
          <HelperTooltip tooltipText="At this time, users cannot retroactively update an ad start/end date. Dates must be selected when associating the creative before sending to the ad server. For more information, please visit the Help page." />
        )}
      </FormLabel>
      <TextField
        id="startDate"
        label="Start date and time"
        type="datetime-local"
        value={startDate.format("YYYY-MM-DDTHH:mm")}
        className={classes.textField}
        InputLabelProps={{
          shrink: true
        }}
        onChange={(e) => dispatch(setStartDate(e.target.value))}
      />
      <TextField
        id="endDate"
        label="End date and time"
        type="datetime-local"
        value={endDate.format("YYYY-MM-DDTHH:mm")}
        className={classes.textField}
        InputLabelProps={{
          shrink: true
        }}
        onChange={(e) => dispatch(setEndDate(e.target.value))}
      />
      <FormControlLabel
        control={
          <Checkbox
            color="secondary"
            value={hardCutoff}
            onChange={(e) => dispatch(setHardCutoff(e.target.checked))}
            checked={hardCutoff}
          />
        }
        label={
          <>
            Hard cut-off
            <HelperTooltip tooltipText="Enable the hard cut-off to stop your creative set from serving after the end date regardless of its status. Seven days after the end date, the status of the creative set will be updated to inactive." />
          </>
        }
        className={classes.label}
      />
    </form>
  );
}
